import * as Cesium from 'cesium';

/**
 * Touch-freundliche Flugzeug-Auswahl.
 *
 * Cesiums Standard-Auswahl trifft nur den exakt angetippten Pixel — auf dem
 * Handy ist das kleine Icon damit schwer zu treffen. Wir ersetzen den
 * LEFT_CLICK-Handler des Viewers durch einen toleranten Pick: ein Rechteck um
 * den Tipp-Punkt (drillPick liefert ALLE Objekte darin, nicht nur das oberste)
 * und wählen daraus das Flugzeug, dessen Icon dem Finger am nächsten liegt —
 * so gewinnt ein Flieger auch gegen darunterliegendes Gelände.
 */
export function setupTouchSelect(viewer) {
  const scene = viewer.scene;

  // Trefferzone je nach Eingabegerät: Touch großzügig, Maus präziser.
  const coarse = window.matchMedia?.('(pointer: coarse)')?.matches;
  const TOL = coarse ? 44 : 18; // Kantenlänge des Pick-Rechtecks in px

  const scratch = new Cesium.Cartesian2();

  function pickFlight(clickPos) {
    // drillPick(pos, limit, width, height): Rechteck um den Tipp-Punkt
    const picks = scene.drillPick(clickPos, 16, TOL, TOL) || [];
    let best = null;
    let bestDist = Infinity;

    for (const p of picks) {
      const entity = p && p.id;
      if (!entity || !entity.flightData) continue;

      // Bildschirm-Abstand des Icons zum Tipp-Punkt bestimmen und den
      // nächstgelegenen Flieger wählen (drillPick sortiert nach Tiefe, nicht
      // nach Abstand zum Finger).
      const world = entity.position?.getValue(viewer.clock.currentTime);
      let dist = 0;
      if (world) {
        const win = Cesium.SceneTransforms.worldToWindowCoordinates(scene, world, scratch);
        if (win) {
          const dx = win.x - clickPos.x;
          const dy = win.y - clickPos.y;
          dist = dx * dx + dy * dy;
        }
      }
      if (dist < bestDist) {
        bestDist = dist;
        best = entity;
      }
    }
    return best;
  }

  viewer.screenSpaceEventHandler.setInputAction((movement) => {
    viewer.selectedEntity = pickFlight(movement.position) || undefined;
  }, Cesium.ScreenSpaceEventType.LEFT_CLICK);
}
